import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "./cn.js";

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn("yatta-label", className)} {...props} />
  ),
);
Label.displayName = "Label";
